export default "__VITE_ASSET__ofbl0GXg__"